import React from 'react';
import { Link } from 'react-router-dom';

const Contact = ({ language }) => {
  const t = (en, id) => language === 'en' ? en : id;

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('Thank you! We will contact you soon.', 'Terima kasih! Kami akan menghubungi Anda segera.'));
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>{t('Get Your Free Quote', 'Dapatkan Penawaran Gratis Anda')}</h1>
        <p>{t('Tell us about your dream pool project', 'Ceritakan proyek kolam impian Anda')}</p>
      </div>

      <div className="contact-container">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label>{t('Full Name', 'Nama Lengkap')}</label>
            <input type="text" required />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" required />
          </div>

          <div className="form-group">
            <label>{t('Phone / WhatsApp', 'Telepon / WhatsApp')}</label>
            <input type="tel" required />
          </div>

          <div className="form-group">
            <label>{t('City / Location', 'Kota / Lokasi')}</label>
            <input type="text" required />
          </div>

          <div className="form-group">
            <label>{t('Project Description', 'Deskripsi Proyek')}</label>
            <textarea rows="6" placeholder={t('Example: 8x4m infinity pool with strong current for training...', 
                                             'Contoh: Kolam infinity 8x4m dengan arus kuat untuk latihan...')} required></textarea>
          </div>

          <button type="submit" className="submit-btn">
            {t('Send Message', 'Kirim Pesan')}
          </button>
        </form>

        <div className="contact-info">
          <h3>{t('Contact Us Directly', 'Hubungi Kami Langsung')}</h3>
          
          <p>📞 +62 22-2345-6789, 6023154, 6022988</p>
          <p>✉️ esawarna_bdg@yahoo.com.</p>
          <p>📍 Jl. Raya Holis No.386, Bandung</p>
        </div>
      </div>

      <div className="back-home">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
};

export default Contact;